import React from 'react';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import { Link } from 'gatsby';

const HomePage = () => (
  <Layout>
    <Sidebar showTabs="false" />
    <div className="container-fluid p-0">
      <section className="resume-section p-3 p-lg-5 d-flex flex-column align-items-center justify-content-center">
        <div className="w-100" style={{ maxWidth: '1200px' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 className="mb-3">Your Journey to Happiness</h1>
            <h2 style={{ fontWeight: 'normal', color: '#666' }}>رحلتك إلى السعادة</h2>
            <p className="lead mt-4" style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '2rem auto' }}>
              A practical guide to spiritual purification (Tazkiah) and growth, based on two authentic Islamic sources:
              <strong> Madarij Assalekeen</strong> by Ibn Al-Qayyim and <strong>Purification of Hearts</strong> by Amr Khalid
            </p>
          </div>

          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h3 className="mb-4">Follow Our Channels</h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
              <a 
                href="https://www.youtube.com/@myislamnet" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  backgroundColor: '#FF0000',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  transition: 'transform 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <i className="fab fa-youtube" style={{ fontSize: '1.5rem' }}></i>
                YouTube Channel
              </a>
              <a 
                href="https://medium.com/@myjourneyinlife" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  backgroundColor: '#000000',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  transition: 'transform 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <i className="fab fa-medium" style={{ fontSize: '1.5rem' }}></i>
                Medium Articles
              </a>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h3>Choose Your Path</h3>
            <p style={{ fontSize: '1.1rem', color: '#666' }}>اختر طريقك</p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            <div style={{ 
              border: '2px solid #BD5D38',
              borderRadius: '12px',
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{ color: '#BD5D38', marginBottom: '1rem' }}>PATH 1: Awakening</h3>
              <h4 style={{ fontWeight: 'normal', marginBottom: '1.5rem' }}>الطريق الأول: اليقظة</h4>
              <h5 style={{ marginBottom: '1rem' }}>Purification of Hearts</h5>
              <h6 style={{ fontWeight: 'normal', marginBottom: '1.5rem' }}>إصلاح القلوب</h6>
              
              <p style={{ marginBottom: '1.5rem', lineHeight: '1.6' }}>
                <strong>Start here if you are:</strong>
              </p>
              <ul style={{ textAlign: 'left', marginBottom: '1.5rem', lineHeight: '1.8' }}>
                <li>New to this spiritual journey</li>
                <li>Feeling spiritually heedless (غافل)</li>
                <li>Seeking to purify your heart</li>
                <li>Ready to awaken from spiritual sleep</li>
              </ul>
              
              <p style={{ fontSize: '0.9rem', fontStyle: 'italic', marginBottom: '1.5rem' }}>
                Based on Amr Khalid's "Purification of Hearts" series
              </p>
              
              <Link 
                to="/hearts/" 
                style={{ 
                  display: 'inline-block',
                  width: '100%',
                  padding: '1rem',
                  backgroundColor: '#BD5D38',
                  color: 'white',
                  textAlign: 'center',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#a04d2f'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#BD5D38'}
              >
                Begin Awakening →
              </Link>
            </div>

            <div style={{ 
              border: '2px solid #17a2b8',
              borderRadius: '12px',
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{ color: '#17a2b8', marginBottom: '1rem' }}>PATH 2: The Journey</h3>
              <h4 style={{ fontWeight: 'normal', marginBottom: '1.5rem' }}>الطريق الثاني: المدارج</h4>
              <h5 style={{ marginBottom: '1rem' }}>Steps of the Travelers</h5>
              <h6 style={{ fontWeight: 'normal', marginBottom: '1.5rem' }}>مدارج السالكين</h6>
              
              <p style={{ marginBottom: '1.5rem', lineHeight: '1.6' }}>
                <strong>Start here if you have:</strong>
              </p>
              <ul style={{ textAlign: 'left', marginBottom: '1.5rem', lineHeight: '1.8' }}>
                <li>Purified your heart</li>
                <li>Completed Path 1 (or equivalent)</li>
                <li>Ready to build spiritual states</li>
                <li>Seeking advanced spiritual growth</li>
              </ul>
              
              <p style={{ fontSize: '0.9rem', fontStyle: 'italic', marginBottom: '1.5rem' }}>
                Based on Ibn Al-Qayyim's "Madarij Assalekeen"
              </p>
              
              <Link 
                to="/madarij/" 
                style={{ 
                  display: 'inline-block',
                  width: '100%',
                  padding: '1rem',
                  backgroundColor: '#17a2b8',
                  color: 'white',
                  textAlign: 'center',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#138496'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#17a2b8'}
              >
                Begin Journey →
              </Link>
            </div>
          </div>

          <div style={{ 
            textAlign: 'center', 
            padding: '2rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            marginBottom: '2rem'
          }}>
            <h4 className="mb-3">Essential Practices (Both Paths)</h4>
            <p style={{ marginBottom: '1.5rem' }}>الممارسات الأساسية</p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1.5rem',
              flexWrap: 'wrap'
            }}>
              <Link to="/duaa/" style={{ textDecoration: 'none' }}>
                <div style={{ 
                  padding: '1rem 1.5rem',
                  backgroundColor: 'white',
                  border: '2px solid #dee2e6',
                  borderRadius: '8px',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = '#BD5D38';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = '#dee2e6';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <strong style={{ color: '#333' }}>Duaa الدعاء</strong>
                </div>
              </Link>
              <Link to="/sins/" style={{ textDecoration: 'none' }}>
                <div style={{ 
                  padding: '1rem 1.5rem',
                  backgroundColor: 'white',
                  border: '2px solid #dee2e6',
                  borderRadius: '8px',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = '#BD5D38';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = '#dee2e6';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <strong style={{ color: '#333' }}>Repentance التوبة</strong>
                </div>
              </Link>
              <Link to="/satan-blocker/" style={{ textDecoration: 'none' }}>
                <div style={{ 
                  padding: '1rem 1.5rem',
                  backgroundColor: 'white',
                  border: '2px solid #dee2e6',
                  borderRadius: '8px',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = '#BD5D38';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = '#dee2e6';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <strong style={{ color: '#333' }}>Protection الحماية</strong>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

export default HomePage;
